module.exports = __webpack_public_path__ + "img/04.c9b93ba7.jpg";